import { motion } from "framer-motion";
import { PageHeader, ContactNudge, FAQItem } from "../components/PolicyHelpers";

const FAQS = [
  {
    q: "How many players are allowed per slot?",
    a: "Oval Cricket Ground accommodates up to 22 players. Box Cricket courts support up to 12 players per court. Pickleball courts are designed for 2–4 players per court.",
  },
  {
    q: "Is parking available?",
    a: "Yes, free parking is available on-site for all players and guests. The facility has dedicated parking spaces adjacent to the main entrance.",
  },
  {
    q: "What if it rains during my slot?",
    a: "In the event of rain, we will do our best to reschedule your slot at no additional charge. If rescheduling is not possible, a full refund will be processed. Please contact us on WhatsApp at +91 91333 03044 as soon as possible.",
  },
  {
    q: "Can I reschedule my booking?",
    a: "Yes, rescheduling is allowed up to 6 hours before your booked slot, subject to availability. Contact us on WhatsApp at +91 91333 03044 or email support@townsquarearena.com to request a reschedule.",
  },
  {
    q: "What sports equipment is provided?",
    a: "Basic equipment such as stumps, bails, and a cricket ball are provided for cricket bookings. Players are encouraged to bring their own bats and protective gear. Pickleball paddles and balls are available on request.",
  },
  {
    q: "What are the operating hours?",
    a: "The facility is open from 5:00 AM to 2:00 AM (next day), 7 days a week, including public holidays. Slots can be booked online up to 14 days in advance.",
  },
  {
    q: "How do I get directions to the facility?",
    a: "Town Square Arena is located in Hyderabad. Detailed directions and a Google Maps link are available on our contact page. You can also WhatsApp us at +91 91333 03044 for directions.",
  },
  {
    q: "Is the facility lit for night play?",
    a: "Yes, all courts and the oval ground are equipped with high-intensity floodlights, making the facility fully operational for night play until 2:00 AM.",
  },
];

export default function FAQ() {
  return (
    <div className="bg-white" style={{ paddingTop: 64 }}>
      <div className="max-w-2xl mx-auto px-4 py-12">

        <PageHeader
          eyebrow="Town Square Arena"
          title="Frequently Asked Questions"
          subtitle="Quick answers to the most common questions about the facility and bookings."
        />

        <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.45, delay: 0.08 }}>
          <div className="space-y-2.5 mb-10">
            {FAQS.map((item, i) => (
              <FAQItem key={i} item={item} index={i} />
            ))}
          </div>
        </motion.div>

        <ContactNudge />
      </div>
    </div>
  );
}
